import React, { useEffect, useState } from 'react';
import { PermissionsResponse } from '../../types';
import { PermissionsContext } from '../../hooks/useUserPermissions';
import { AuthenticatedClient } from '../../api/authenticatedClient';
import { MockAuthenticatedClient } from '../../api/mockAuthenticatedClient';
import { AuthenticatedApiContext } from '../../api/useApiClient';
import { authenticatedApiClient } from '../../apiClient';
import { AuthContext } from '../../auth';
import { AuthCallbacks } from '../../auth/Auth';
import { Shell } from '../Shell/Shell';
import { FullPageSpinner } from '../FullPageSpinner';

interface Props {
  auth: AuthCallbacks;
}

const getAuthClient = (auth: AuthCallbacks) => {
  /* istanbul ignore next */
  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_MOCK_API_DATA === 'true') {
    // TODO(AMP-214): Remove mock data when we are ready
    return new MockAuthenticatedClient();
  }
  return new AuthenticatedClient(authenticatedApiClient(auth));
};

export const AuthenticatedArea: React.VFC<Props> = ({ auth }) => {
  const authClient = getAuthClient(auth);
  const [permissions, setPermissions] = useState<PermissionsResponse>({ permissions: [] });

  useEffect(() => {
    async function getPermissions() {
      const data = await authClient.getPermissions();
      setPermissions(data);
    }
    if (permissions.permissions.length === 0) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      getPermissions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissions.permissions.length]);

  return permissions.permissions.length ? (
    <AuthContext.Provider value={auth}>
      <AuthenticatedApiContext.Provider value={authClient}>
        <PermissionsContext.Provider value={permissions}>
          <Shell></Shell>
        </PermissionsContext.Provider>
      </AuthenticatedApiContext.Provider>
    </AuthContext.Provider>
  ) : (
    <FullPageSpinner />
  );
};
